
/**
 * 메시지 역할
 */
export type ConversationMessageRole = typeof ConversationMessageRole[keyof typeof ConversationMessageRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConversationMessageRole = {
  USER: 'USER',
  ASSISTANT: 'ASSISTANT',
  SYSTEM: 'SYSTEM',
} as const;
